module.exports = __webpack_public_path__ + "img/b.331dfe28.jpg";